module.exports = __webpack_public_path__ + "static/media/underline.83bf4547.svg";